import { render, staticRenderFns } from "./ServiceLabItemAutocompleteSingle.vue?vue&type=template&id=4c62958a"
import script from "./ServiceLabItemAutocompleteSingle.vue?vue&type=script&lang=js"
export * from "./ServiceLabItemAutocompleteSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports